import { SchedulerTaskProgramChecklist } from './scheduler-task-program-checklist';

export class SchedulerTaskProgramsChecklist {
  constructor(
    public pocketsNumber?: number,
    public reservedPockets?: number[],
    public schedulerTaskProgramsChecklist?: SchedulerTaskProgramChecklist[]
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-programs-checklist.ts